if (!customElements.get("media-grid-button")) {
	customElements.define(
		"media-grid-button",
		class MediaGridButton extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.target = document.getElementById(this.dataset.target);
				this.action = this.dataset.action;

				this.addEventListener("click", () => {
					this.action === "prev" ? this.goPreviousSlide() : this.goNextSlide();
				});

				this.updateButtonVisibility();

				this.target.addEventListener("scroll", () => {
					this.updateButtonVisibility();
				});
			}

			updateButtonVisibility() {
				const isAtStart = this.target.scrollLeft <= 0;
				const isAtEnd =
					this.target.scrollLeft + this.target.offsetWidth >=
					this.target.scrollWidth - 1;

				if (this.action === "prev") {
					isAtStart
						? this.classList.add("button--hidden")
						: this.classList.remove("button--hidden");
				} else {
					isAtEnd
						? this.classList.add("button--hidden")
						: this.classList.remove("button--hidden");
				}
			}

			goPreviousSlide() {
				const scrollAmount =
					400 + parseInt(getComputedStyle(this.target).gap) || 400;
				this.target.scrollBy({
					left: -scrollAmount,
					behavior: "smooth",
				});
			}

			goNextSlide() {
				const scrollAmount =
					400 + parseInt(getComputedStyle(this.target).gap) || 400;
				this.target.scrollBy({
					left: scrollAmount,
					behavior: "smooth",
				});
			}
		}
	);
}
